import { AbstractControl, Validators } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class EmailAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            required: 'Este campo es requerido',
            bad_email: 'Correo electrónico incorrecto, debe ser por ejemplo: juan@dominio.com'
        },
        'en-US': {
            required: 'This field is required',
            bad_email: 'Incorrect email, it must be for example: john@domain.com'
        }
    };
    protected static label: any = {
        'es-AR': 'Correo electrónico de tu cuenta de',
        'en-US': 'Email of your account'
    };
    protected static placeholder: any = {
        'es-AR': 'Por ejemplo: juan@dominio.com',
        'en-US': 'For example: john@domain.com'
    };

    public getLabelToAccountType(): string {
        return EmailAccountValidator.label[EmailAccountValidator.lang] ?? EmailAccountValidator.label['es-AR'];
    }

    public getPlaceholderToAccountType(): string {
        return EmailAccountValidator.placeholder[EmailAccountValidator.lang] ?? EmailAccountValidator.placeholder['es-AR'];
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any = EmailAccountValidator.errors[EmailAccountValidator.lang] ?? EmailAccountValidator.errors['es-AR'];
        if (Validators.required(control) !== null) {
            return { forbiddenName: error.required };
        }
        if (Validators.email(control) !== null) {
            return { forbiddenName: error.bad_email };
        }

        return null;
    }
}
